<template>
    <div :class="styles.placeholder" />
</template>
<script setup>
import styles from './AnimatedPlaceholder.module.css'
</script>
